import React from 'react';
import { companyInfo } from '../data/mock';
import { MapPin, Navigation } from 'lucide-react';

const ServiceArea = () => {
  return (
    <section id="service-gebiet" className="py-12 md:py-16 lg:py-24 bg-[#FAFAFF]">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Content Side */}
          <div>
            <span className="inline-block text-[#FFD700] font-semibold text-xs sm:text-sm uppercase tracking-wider mb-2 sm:mb-4">
              Unser Einsatzgebiet
            </span>
            <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-[#1E4D2B] mb-4 sm:mb-6 leading-tight">
              Frankfurt, Kahl am Main<br className="hidden sm:block" />
              <span className="text-[#2D5F3A]"> und das Rhein-Main-Gebiet</span>
            </h2>
            <p className="text-[#2D5F3A] text-base sm:text-lg mb-8 leading-relaxed">
              Wir sind Ihr lokaler Partner für den Großraum Frankfurt. Unser Service erstreckt sich
              von Kahl am Main bis tief in das gesamte Rhein-Main-Gebiet. Kurze Wege bedeuten
              schnelle Reaktionszeiten für Sie.
            </p>

            {/* Address Card */}
            <div className="bg-white rounded-[32px] p-6 sm:p-8 shadow-sm border border-[#D4DCC9]/30">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 sm:w-14 sm:h-14 bg-[#FFD700] rounded-2xl flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 sm:w-7 sm:h-7 text-[#1E4D2B]" />
                </div>
                <div>
                  <h3 className="font-semibold text-[#1E4D2B] text-base sm:text-lg mb-1 sm:mb-2">
                    Unser Standort
                  </h3>
                  <p className="text-sm sm:text-base text-[#2D5F3A] leading-relaxed">
                    {companyInfo.address.street}<br />
                    {companyInfo.address.zip} {companyInfo.address.city}
                  </p>
                  <a
                    href={`https://maps.google.com/?q=${encodeURIComponent(
                      `${companyInfo.address.street}, ${companyInfo.address.zip} ${companyInfo.address.city}`
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 mt-4 text-[#1E4D2B] font-semibold text-sm sm:text-base hover:text-[#2D5F3A] transition-colors"
                  >
                    <Navigation className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                    Route planen
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Map Side */}
          <div className="relative">
            <div className="rounded-[32px] overflow-hidden shadow-2xl bg-[#E8EDE4] h-[350px] sm:h-[400px] md:h-[500px]">
              <iframe
                title="Standort MeisterGrün"
                src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${encodeURIComponent(
                  `${companyInfo.address.street}, ${companyInfo.address.zip} ${companyInfo.address.city}`
                )}&zoom=14`}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            {/* Service Radius Badge */}
            <div className="absolute -top-3 -left-3 sm:-top-4 sm:-left-4 bg-[#1E4D2B] text-white rounded-xl sm:rounded-2xl px-4 py-2 sm:px-6 sm:py-3 shadow-lg">
              <span className="text-xs sm:text-base font-semibold">Schnell vor Ort</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceArea;
